var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSevLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159,
    height: 44,
    viewBox: "0 0 159 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sev-logo",
    transform: "translate(-9.048 42.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5189",
    "data-name": "Group 5189",
    transform: "translate(9.048 -42.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5188",
    "data-name": "Group 5188",
    transform: "translate(55.235 0.613)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6387",
    "data-name": "Rectangle 6387",
    width: 4.537,
    height: 3.67,
    transform: "translate(99.228 0.013)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4333",
    "data-name": "Path 4333",
    d: "M43.671-28.839v9.948H38.542v-9.948l-4.5-13.025H39.49l1.618,6.393,1.657-6.393h5.443Z",
    transform: "translate(-34.043 41.893)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4334",
    "data-name": "Path 4334",
    d: "M46.7-21.7l-.2-.871a4.031,4.031,0,0,1-3.434,1.3c-1.894.04-3.237-1.7-3.2-3.789l.04-2.96c.082-4.815,6.629-3.356,6.629-6.946,0-.754-.038-1.384-.908-1.384-.829,0-1.065.63-1.065,1.384V-33.5H39.913v-1.459c0-3.119,2.683-4.582,5.721-4.582,3.867,0,5.644,2.171,5.644,4.54v13.3Zm-.239-8.763c-1.1.71-1.894,1.066-1.894,2.522v2.135c0,1.023.278,1.421.948,1.421s.946-.4.946-1.421Z",
    transform: "translate(-26.99 44.701)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4335",
    "data-name": "Path 4335",
    d: "M57.466-26.414c0,2.763-.471,5.082-3.547,5.082a3.583,3.583,0,0,1-3.354-1.578v5.369H46.03V-39.169h4.535L50.527-37.4a3.561,3.561,0,0,1,3.628-2.129c2.484,0,3.315,2.368,3.315,4.616v8.449Zm-4.851-8.139c0-.789-.431-1.222-1.023-1.222-.632,0-1.065.473-1.065,1.3v8.248c0,.789.433,1.225,1.023,1.225.634,0,1.065-.435,1.065-1.262Z",
    transform: "translate(-19.541 44.724)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4336",
    "data-name": "Path 4336",
    d: "M52.191-21.94V-39.346h4.537V-21.94Z",
    transform: "translate(-12.088 44.941)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4337",
    "data-name": "Path 4337",
    d: "M64.094-18.9l-2.966-8.053-.7,1.264V-18.9H55.3V-41.877h5.127v7.14l3.273-7.14h5.089l-4.691,9.669,5.089,13.3Z",
    transform: "translate(-8.33 41.877)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4338",
    "data-name": "Path 4338",
    d: "M70.865-34.373c-1.14-.433-4.179-.473-4.179,2.33V-21.7H62.147V-39.106H66.37l-.042,1.852a4.8,4.8,0,0,1,4.5-2.29v5.171Z",
    transform: "translate(-0.043 44.701)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4339",
    "data-name": "Path 4339",
    d: "M78.086-26.132c0,3.473-2.4,4.821-5.677,4.821-3,0-5.681-1.463-5.681-4.894v-8.133c0-3.314,2.013-5.171,5.681-5.171,3,0,5.679,1.225,5.679,5.213v4.578H71.424v4.182c0,.71.312,1.107.986,1.107s.988-.4.988-1.107V-28.1h4.691v2.007Zm-4.771-9.154c0-.707-.314-1.1-.946-1.1-.67,0-.986.4-.986,1.1v2.37h1.973Z",
    transform: "translate(5.499 44.745)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4340",
    "data-name": "Path 4340",
    d: "M79.693-18.892v-1.777c-.431,1.539-1.852,2.133-3.551,2.133-2.8,0-3.352-2.37-3.352-4.578v-8.451c0-2.761.672-5.171,3.472-5.171a4.031,4.031,0,0,1,3.432,1.581v-6.709h4.539v22.972Zm0-12.947c0-.789-.431-1.225-1.063-1.185-.632,0-1.067.433-1.067,1.222l.04,8.29c0,.794.438,1.222,1.028,1.222.632,0,1.063-.473,1.063-1.264Z",
    transform: "translate(12.833 41.893)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    "data-name": "Path 4341",
    d: "M78.947-21.931v-17.4h4.537v17.4Z",
    transform: "translate(20.282 44.954)",
    fill: "#003368"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4342",
    "data-name": "Path 4342",
    d: "M62.537-33.221C59.6-41.663,51.194-42.131,50.33-42.151a15.464,15.464,0,0,0-11.082,4.326,19.686,19.686,0,0,0-3.136,3.9l0,0,0,0a19.587,19.587,0,0,0-3.131-3.9,15.473,15.473,0,0,0-11.084-4.326c-.864.02-9.27.489-12.2,8.931a12.8,12.8,0,0,0,.756,9.813c1.545,3.32,5.246,6.024,9.146,5.75a8,8,0,0,0,7.071-4.773,6.909,6.909,0,0,0-1.547-7.6,2.756,2.756,0,0,1-.48,2.08A3.074,3.074,0,0,1,20.88-26.94a2.493,2.493,0,0,1-1.64-2.743,2.913,2.913,0,0,1,1.805-2.248c1.708-.741,3.284-.365,4.824,1.1,2.521,2.821,2.815,7.094,4.013,10.334.849,2.67,2.19,4.989,5.136,5.655a4.726,4.726,0,0,0,1.089.115h0A4.732,4.732,0,0,0,37.2-14.84c2.946-.665,4.289-2.984,5.136-5.655,1.2-3.241,1.492-7.514,4.013-10.334,1.54-1.468,3.116-1.844,4.824-1.1a2.906,2.906,0,0,1,1.8,2.248,2.487,2.487,0,0,1-1.637,2.743,3.074,3.074,0,0,1-3.754-1.015,2.776,2.776,0,0,1-.48-2.08,6.912,6.912,0,0,0-1.547,7.6,8,8,0,0,0,7.069,4.773c3.9.274,7.6-2.429,9.151-5.75A12.833,12.833,0,0,0,62.537-33.221ZM56.605-23.147a5.749,5.749,0,0,1-6.092,1.161A4.136,4.136,0,0,1,48.25-24.6c1.62,1.616,4.55,2.436,7.233-.391,0,0,2.515-2.33,1.087-6.716a7.068,7.068,0,0,0-5.578-4.2,8.435,8.435,0,0,0-8.561,3.61c-2.541,3.924-2.862,8.29-4.7,12.655a1.609,1.609,0,0,1-1.618,1h0a1.608,1.608,0,0,1-1.615-1c-1.841-4.366-2.161-8.732-4.7-12.655a8.44,8.44,0,0,0-8.563-3.61,7.071,7.071,0,0,0-5.578,4.2C14.224-27.325,16.739-25,16.739-25c2.683,2.827,5.611,2.007,7.235.391a4.146,4.146,0,0,1-2.265,2.617,5.752,5.752,0,0,1-6.095-1.161,8.463,8.463,0,0,1-1.987-9.061c1.264-3.758,5.063-5.637,8.081-5.873,3.573-.316,8.508,1.877,10.477,5.617.457.864,1.421,3.095,1.421,3.095l2.5,0,2.506,0s.961-2.23,1.423-3.095c1.969-3.74,6.9-5.933,10.474-5.617,3.019.237,6.817,2.116,8.083,5.873A8.457,8.457,0,0,1,56.605-23.147Z",
    transform: "translate(-9.048 42.154)",
    fill: "#b1b0b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5190",
    "data-name": "Group 5190",
    transform: "translate(68.501 -10.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4343",
    "data-name": "Path 4343",
    d: "M40.04-25.743c0-.7-.362-1.161-1.565-1.161-1.187,0-1.551.46-1.551,1.161v.581a1.092,1.092,0,0,0,.714,1.092l2.106.959a1.823,1.823,0,0,1,1.229,1.7v1.256c0,1.026-.608,1.875-2.51,1.875s-2.51-.849-2.51-1.875v-.811c0-.148.053-.2.19-.2h.513c.122,0,.175.053.175.2v.743c0,.716.418,1.174,1.633,1.174,1.2,0,1.62-.458,1.62-1.174v-.986c0-.661-.473-.97-.972-1.2l-2.011-.92a1.781,1.781,0,0,1-1.052-1.634V-25.8c0-1.026.539-1.877,2.429-1.877s2.442.851,2.442,1.877v.729a.164.164,0,0,1-.188.188h-.5c-.148,0-.19-.066-.19-.188Z",
    transform: "translate(-35.952 27.89)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4344",
    "data-name": "Path 4344",
    d: "M38.975-24.917c0-.959.526-1.62,2.1-1.62,1.607,0,2.106.661,2.106,1.62v4.954c0,.135-.04.2-.175.2h-.446c-.135,0-.175-.055-.188-.2l-.029-.418a2.891,2.891,0,0,1-1.876.727,1.432,1.432,0,0,1-1.618-1.47v-.9a1.435,1.435,0,0,1,1.6-1.472H42.32v-1.377c0-.553-.256-.944-1.255-.944s-1.268.376-1.268.931v.3c0,.135-.053.19-.188.19h-.46c-.135,0-.175-.055-.175-.19Zm3.346,3.86v-1.755H40.634a.82.82,0,0,0-.933.92v.621c0,.566.312.875,1.012.875A2.476,2.476,0,0,0,42.32-21.057Z",
    transform: "translate(-32.442 29.265)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4345",
    "data-name": "Path 4345",
    d: "M41.576-19.809v-3.807a1.432,1.432,0,0,1,1.607-1.539,3.059,3.059,0,0,1,1.969.743l.029-.433c.013-.135.053-.2.188-.2h.446c.135,0,.188.066.188.2v7.534c0,.973-.579,1.634-2.185,1.634h-1.58c-.135,0-.188-.053-.188-.19v-.363c0-.137.053-.19.188-.19H43.8c1.025,0,1.321-.391,1.321-.973v-1.578a3.055,3.055,0,0,1-1.942.7A1.432,1.432,0,0,1,41.576-19.809Zm1.35-7.412c0,.5.122.864.769.864s.782-.365.782-.864v-.3c0-.108.04-.161.161-.161h.312c.122,0,.175.053.175.161v.27a1.278,1.278,0,0,1-1.443,1.459c-1.067,0-1.416-.568-1.416-1.459v-.27c0-.108.053-.161.175-.161h.309c.137,0,.177.053.177.161Zm-.473,7.251c0,.5.256.9.986.9a2.667,2.667,0,0,0,1.686-.661v-3.957a2.6,2.6,0,0,0-1.686-.674c-.716,0-.986.4-.986.9Z",
    transform: "translate(-29.148 27.882)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4346",
    "data-name": "Path 4346",
    d: "M45.274-18.521c0,.135-.053.2-.188.2h-.5c-.135,0-.19-.069-.19-.2v-9c0-.137.055-.2.19-.2h.5c.135,0,.188.066.188.2Z",
    transform: "translate(-25.735 27.823)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4347",
    "data-name": "Path 4347",
    d: "M46.49-20.009a.167.167,0,0,1-.19.19h-.5c-.135,0-.188-.069-.188-.19v-6.278c0-.135.053-.2.188-.2h.5c.135,0,.19.066.19.2Z",
    transform: "translate(-24.264 29.324)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4348",
    "data-name": "Path 4348",
    d: "M51.212-18.508c.068.1.015.19-.106.19h-.65a.329.329,0,0,1-.283-.19L48.054-21.72h-.349v3.212a.167.167,0,0,1-.19.19h-.5c-.135,0-.188-.069-.188-.19V-27.54a.164.164,0,0,1,.188-.188h.5a.165.165,0,0,1,.19.188v5.131h.365l1.916-2.39a.394.394,0,0,1,.3-.188h.581c.135,0,.188.093.108.2L48.8-22.1Z",
    transform: "translate(-22.794 27.823)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4349",
    "data-name": "Path 4349",
    d: "M50.711-18.444c-.122,0-.177-.069-.177-.2v-8.776c0-.135.055-.2.19-.2h3.927c.135,0,.19.053.19.188v.391c0,.137-.055.19-.19.19H51.44v3.212h3.008c.137,0,.2.055.2.19v.378c0,.135-.066.188-.2.188H51.44v3.672H54.8c.122,0,.19.042.19.177v.4a.167.167,0,0,1-.19.19Z",
    transform: "translate(-18.311 27.949)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4350",
    "data-name": "Path 4350",
    d: "M53.856-26.429c.135,0,.19.066.19.2l.013.42a2.853,2.853,0,0,1,1.916-.729,1.473,1.473,0,0,1,1.472.822,2.926,2.926,0,0,1,2.024-.822,1.434,1.434,0,0,1,1.6,1.5v5.075c0,.135-.053.2-.188.2H60.4c-.148,0-.2-.069-.2-.2v-4.874c0-.539-.285-.9-.986-.9a2.446,2.446,0,0,0-1.646.674,1.6,1.6,0,0,1,.013.23v4.874c0,.135-.055.2-.19.2h-.5c-.135,0-.188-.069-.188-.2v-4.874c0-.539-.283-.9-1-.9a2.4,2.4,0,0,0-1.62.661v5.117c0,.135-.053.2-.188.2h-.5c-.135,0-.19-.069-.19-.2v-6.265c0-.135.055-.2.19-.2Z",
    transform: "translate(-15.075 29.265)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4351",
    "data-name": "Path 4351",
    d: "M61.824-23.148c0,.122-.055.188-.177.188H58.382v1.66c0,.542.285.933,1.3.933,1.039,0,1.308-.391,1.308-.933v-.365c0-.119.053-.188.2-.188h.431c.135,0,.2.069.2.188v.365c0,.973-.528,1.647-2.146,1.647s-2.146-.674-2.146-1.647v-3.59c0-.973.526-1.647,2.146-1.647s2.146.674,2.146,1.647Zm-3.443-.486h2.605V-24.89c0-.539-.3-.931-1.308-.931s-1.3.391-1.3.931Z",
    transform: "translate(-9.843 29.265)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4352",
    "data-name": "Path 4352",
    d: "M64.6-18.508c.069.1.013.19-.108.19h-.647a.326.326,0,0,1-.283-.19L61.442-21.72H61.09v3.212c0,.122-.053.19-.188.19h-.5a.167.167,0,0,1-.19-.19V-27.54a.165.165,0,0,1,.19-.188h.5a.164.164,0,0,1,.188.188v5.131h.365l1.916-2.39a.4.4,0,0,1,.3-.188h.579c.135,0,.19.093.108.2L62.184-22.1Z",
    transform: "translate(-6.601 27.823)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4353",
    "data-name": "Path 4353",
    d: "M63.57-18.521c0,.135-.055.2-.19.2h-.5c-.135,0-.188-.069-.188-.2v-9c0-.137.053-.2.188-.2h.5c.135,0,.19.066.19.2Z",
    transform: "translate(-3.601 27.823)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4354",
    "data-name": "Path 4354",
    d: "M64.785-26.271c0,.137-.055.19-.19.19h-.5c-.135,0-.188-.053-.188-.19v-1.253c0-.137.053-.2.188-.2h.5c.135,0,.19.066.19.2Zm0,7.75c0,.135-.055.2-.19.2h-.5c-.135,0-.188-.069-.188-.2v-6.265c0-.135.053-.2.188-.2h.5c.135,0,.19.066.19.2Z",
    transform: "translate(-2.131 27.823)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    "data-name": "Path 4355",
    d: "M66-18.521c0,.135-.055.2-.19.2h-.5c-.135,0-.188-.069-.188-.2v-9c0-.137.053-.2.188-.2h.5c.135,0,.19.066.19.2Z",
    transform: "translate(-0.661 27.823)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4356",
    "data-name": "Path 4356",
    d: "M67.215-26.271c0,.137-.053.19-.188.19h-.5c-.135,0-.19-.053-.19-.19v-1.253c0-.137.055-.2.19-.2h.5c.135,0,.188.066.188.2Zm0,7.75c0,.135-.053.2-.188.2h-.5c-.135,0-.19-.069-.19-.2v-6.265c0-.135.055-.2.19-.2h.5c.135,0,.188.066.188.2Z",
    transform: "translate(0.809 27.823)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4357",
    "data-name": "Path 4357",
    d: "M71.939-18.508c.069.1.013.19-.108.19h-.647a.326.326,0,0,1-.283-.19L68.782-21.72H68.43v3.212c0,.122-.053.19-.188.19h-.5a.167.167,0,0,1-.19-.19V-27.54a.165.165,0,0,1,.19-.188h.5a.164.164,0,0,1,.188.188v5.131h.365l1.916-2.39a.4.4,0,0,1,.3-.188h.579c.135,0,.19.093.108.2L69.524-22.1Z",
    transform: "translate(2.279 27.823)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    "data-name": "Path 4358",
    d: "M73.4-18.444a.227.227,0,0,1-.243-.19l-2.281-8.8c-.04-.135.013-.188.135-.188h.568a.212.212,0,0,1,.23.188l1.633,6.4c.08.325.175.944.228,1.351.055-.3.19-1.026.272-1.337l1.646-6.413a.2.2,0,0,1,.214-.188h.526c.137,0,.19.053.15.188l-2.3,8.8a.219.219,0,0,1-.228.19Z",
    transform: "translate(6.283 27.949)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4359",
    "data-name": "Path 4359",
    d: "M73.794-24.917c0-.959.526-1.62,2.106-1.62,1.607,0,2.106.661,2.106,1.62v4.954c0,.135-.042.2-.177.2h-.444c-.135,0-.177-.055-.19-.2l-.027-.418a2.9,2.9,0,0,1-1.876.727,1.433,1.433,0,0,1-1.62-1.47v-.9A1.435,1.435,0,0,1,75.279-23.5h1.863v-1.377c0-.553-.256-.944-1.255-.944s-1.268.376-1.268.931v.3c0,.135-.055.19-.19.19H73.97c-.137,0-.177-.055-.177-.19Zm3.348,3.86v-1.755H75.453a.819.819,0,0,0-.93.92v.621c0,.566.309.875,1.012.875A2.481,2.481,0,0,0,77.141-21.057Z",
    transform: "translate(9.682 29.265)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4360",
    "data-name": "Path 4360",
    d: "M80.824-18.508c.069.1.013.19-.108.19h-.647a.329.329,0,0,1-.283-.19L77.667-21.72h-.351v3.212c0,.122-.053.19-.188.19h-.5a.167.167,0,0,1-.19-.19V-27.54a.165.165,0,0,1,.19-.188h.5a.164.164,0,0,1,.188.188v5.131h.365L79.6-24.8a.4.4,0,0,1,.3-.188h.579c.137,0,.19.093.108.2L78.409-22.1Z",
    transform: "translate(13.028 27.823)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4361",
    "data-name": "Path 4361",
    d: "M79.54-24.908v-1.216c0-.97.594-1.647,2.2-1.647h.082c.122,0,.19.055.19.2v.365a.165.165,0,0,1-.19.188h-.082c-1,0-1.321.391-1.321.959v1.147h1.242a.164.164,0,0,1,.188.188v.351a.165.165,0,0,1-.188.19H80.417v5.71c0,.135-.053.2-.19.2h-.5c-.137,0-.19-.069-.19-.2v-5.71h-.716c-.122,0-.175-.055-.175-.19v-.309a.167.167,0,0,1,.175-.19l.621-.04Z",
    transform: "translate(15.703 27.771)",
    fill: "#003368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4362",
    "data-name": "Path 4362",
    d: "M81.48-20.009a.166.166,0,0,1-.19.19h-.5a.166.166,0,0,1-.19-.19v-6.278c0-.135.053-.2.19-.2h.5c.137,0,.19.066.19.2Z",
    transform: "translate(18.067 29.324)",
    fill: "#003368"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSevLogo);
export default __webpack_public_path__ + "static/media/sev-logo.f4237361f177b1e324dd2db3a9843f36.svg";
export { ForwardRef as ReactComponent };